export default {
    lines(value, maxWidth, ctx) {
        let currentLine = "",
            currentLineOffset = 0,
            lines = [];
        for(let i = 0; i<value.length; i++) {
            let currentText = textPart(value, currentLineOffset, i);
            while(ctx.measureText(currentText).width < maxWidth) {
                currentLine += value[i++];
                if (i >= value.length) {
                    break;
                } 
                currentText = textPart(value, currentLineOffset, i);
            }
            lines.push(currentLine);
            currentLineOffset = i;
            i--;
            currentLine = "";
        }
        return lines;
    }
}

function textPart(value, offset, i) {
    const currentText = value.substring(offset, i);
    return currentText;
}
